(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const arrowPrev = '<button type="button" class="slick-prev"><svg><use xlink:href="/common/svg/sprite.svg#arrow_left2" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg><use xlink:href="/common/svg/sprite.svg#arrow_right2" /></svg></button>';

	// ＜共通＞ ==========================================================================
	const headerMenu = () => {
		let $menu = $('.recruit-header-menu');
		let $menucontent = $('.recruit-header-nav');
		var flag = false;
		var scrollTopNow;

		// ハンバーガーメニュー
		$menu.on('click', () => {
			if (!flag) {
				scrollTopNow = document.body.scrollTop + document.documentElement.scrollTop;
				$menu.addClass(a);
				$menucontent.addClass(a);
				$('.container').css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				$('body').addClass(f);
				flag = true;
			} else {
				$menu.removeClass(a);
				$menucontent.removeClass(a);
				$('.container').css({
					position: 'static',
				});
				$('body').removeClass(f);

				$(window).scrollTop(scrollTopNow);
				flag = false;
			}
		});

		// スクロールしたら背景白に
		$(window).scroll((e) => {
			let thisScroll = $(e.currentTarget).scrollTop();
			if (thisScroll > 0) {
				$('.recruit-header').addClass(a);
			} else {
				$('.recruit-header').removeClass(a);
			}
		});
	};
	const pageTop = () => {
		let $pagetop = $('.recruit-footer-pagetop');

		if (FUNCTIONS.va.window.width >= 1024) {
			$(window).scroll((e) => {
				let $this = $(e.currentTarget);
				let $footer = $('.recruit-footer');
				let footerPos = $footer.offset().top + $footer.height();
				let thisScroll = $this.scrollTop();
				let pagetopPos = $this.height() + $footer.height() + thisScroll;

				if (thisScroll > '150') {
					$pagetop.addClass(v);
				} else {
					$pagetop.removeClass(v);
				}
				if (footerPos <= pagetopPos) {
					$pagetop.addClass('is-bottom');
				} else {
					$pagetop.removeClass('is-bottom');
				}
			});
		};
	};
	const memberSlider = () => {
		$('.js-member-slider').slick({
			autoplay: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplaySpeed: 5000,
			infinite: false,
			dots: false,
			arrows: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
	};
	const sideNavCurrent = () => {
		let $nav = $('.recruit-sideNav-nav');
		$nav.find('a').each((idx, ele) => {
			if (FUNCTIONS.va.pathname === $(ele).attr('href')) {
				$(ele).addClass(a);
			}
		});
	};

	// ＜トップ＞ ========================================================================
	const idxMainMovie = () => {
		let videoSrc;
		if ($(window).width() >= 768) {
			videoSrc = '//s3-ap-northeast-1.amazonaws.com/aws-s3-noda/recruit/mainVideo.mp4';
		} else {
			videoSrc = '//s3-ap-northeast-1.amazonaws.com/aws-s3-noda/recruit/mainVideo_sp.mp4';
		}
		// 動画遅延読み込み
		let xhr = new XMLHttpRequest();
		xhr.open('GET', videoSrc, true);
		xhr.responseType = 'blob';
		xhr.onload = function (e) {
			if (this.status === 200) {
				let blob = this.response;
				let src = (window.webkitURL || window.URL).createObjectURL(blob);
				$('.js-mainVisVideo').append('<source type="video/mp4" src="' + src + '">');
				$('.js-mainVisVideo').get(0).play();
			}
		};
		xhr.send();
	}
	const idxJobSlider = () => {
		$('.js-job-thumb').slick({ // メイン画像
			autoplay: true,
			autoplaySpeed: 2000,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
			fade: true,
		});
		$('.js-job-slide').slick({
			autoplay: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			variableWidth: true,
			pauseOnHover: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						variableWidth: false,
					}
				}
			]
		});

		// スライドアイテムホバー時にメイン画像を切り替え
		$('.js-job-slide').find('.slick-slide').each((idx, ele) => {
			$(ele).hover((e) => {
				$('.js-job-thumb').slick('slickGoTo', $(e.currentTarget).attr('data-slick-index'));
				$('.js-job-thumb').slick('slickPause');
			}, () => {
				$('.js-job-thumb').slick('slickPlay');
			});
		});
	};
	const idxMemberSlider = () => {
		$('.js-member-slider').slick({
			autoplay: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplaySpeed: 5000,
			infinite: true,
			dots: false,
			arrows: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
	};
	const idxPopupMovie = () => {
		$('.js-popupMovie').magnificPopup({
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false
		});
	};

	// 歴史 ========================================================================
	const historySetHeight = () => {
		let promiseImgLoad = new Promise((resolve) => {
			let count = 0, LENGTH = $('.__item img').length;

			$('.__item').each((idx, ele) => {
				let historyImg = new Image();
				historyImg.onload = () => {
					count++;
					if (count === LENGTH) { return resolve('Success'); }
				};
				historyImg.onerror = () => {
					count++;
					if (count === LENGTH) { return resolve('Success'); }
				}
				historyImg.src = $(ele).find('img').attr('src');
			});
		});
		Promise.all([promiseImgLoad]).then(() => {
			const setListHeight = () => {
				if ($(window).width() > 1024 - 17) { // スクロールバーの分？
					$('.__historyList').each((idx, ele) => {
						var $lastItem = $(ele).find('li:last-child');
						var pos = $lastItem.offset().top + $lastItem.innerHeight();
						$(ele).css({ height: (pos - $(ele).offset().top) + 'px' });
					});
				} else {
					$('.__historyList').each((idx, ele) => {
						$(ele).css({ height: 'auto' });
					});
				}
			}
			setListHeight();
			$(window).resize(() => {
				setListHeight();
			});
		});
	};

	// ========= ↑↑ FUNCTIONS ↑↑ ========================================================================== //

	headerMenu();
	pageTop();
	sideNavCurrent();

	if (location.pathname === '/recruit/' || location.pathname === '/recruit/index.html') {
		idxMainMovie();
		idxJobSlider();
		idxPopupMovie();
		idxMemberSlider();
	} else if (location.pathname === '/recruit/people/' || location.pathname === '/recruit/people/index.html') {
		idxPopupMovie();
	} else if (location.pathname.indexOf('/recruit/about/history.html') !== -1) {
		historySetHeight();
	} else if (location.pathname.indexOf('/recruit/job/') !== -1) {
		memberSlider();
	}

})(window.jQuery, window.FUNCTIONS);
